/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DisplayedProfile } from './';
import {
    DisplayedProfileFromJSON,
    DisplayedProfileFromJSONTyped,
    DisplayedProfileToJSON,
} from './';

/**
 * 
 * @export
 * @interface TrackAdvancedSearchDisplayedProfilesRequest
 */
export interface TrackAdvancedSearchDisplayedProfilesRequest {
    /**
     * 
     * @type {string}
     * @memberof TrackAdvancedSearchDisplayedProfilesRequest
     */
    advancedSearchQueryId: string;
    /**
     * 
     * @type {Array<DisplayedProfile>}
     * @memberof TrackAdvancedSearchDisplayedProfilesRequest
     */
    profiles: Array<DisplayedProfile>;
}

/**
 * Check if a given object implements the TrackAdvancedSearchDisplayedProfilesRequest interface.
 */
export function instanceOfTrackAdvancedSearchDisplayedProfilesRequest(value: object): value is TrackAdvancedSearchDisplayedProfilesRequest {
    if (!('advancedSearchQueryId' in value) || value['advancedSearchQueryId'] === undefined) return false;
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    return true;
}

export function TrackAdvancedSearchDisplayedProfilesRequestFromJSON(json: any): TrackAdvancedSearchDisplayedProfilesRequest {
    return TrackAdvancedSearchDisplayedProfilesRequestFromJSONTyped(json, false);
}

export function TrackAdvancedSearchDisplayedProfilesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackAdvancedSearchDisplayedProfilesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'advancedSearchQueryId': json['advancedSearchQueryId'],
        'profiles': ((json['profiles'] as Array<any>).map(DisplayedProfileFromJSON)),
    };
}

export function TrackAdvancedSearchDisplayedProfilesRequestToJSON(value?: TrackAdvancedSearchDisplayedProfilesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'advancedSearchQueryId': value['advancedSearchQueryId'],
        'profiles': ((value['profiles'] as Array<any>).map((v) => DisplayedProfileToJSON(v))),
    };
}

